<template>
  <v-container>
    <div class="tableTitle">金額</div>
    <div class="tableSubTitle">金額</div>
    <table>
      <tr>
        <th>基本給</th>
        <td>{{toFormattedMoney(owner.base_salary)}}</td>
      </tr>
      <tr>
        <th>超過勤務手当​</th>
        <td>{{toFormattedMoney(moneyCounts.overtime)}}</td>
      </tr>
      <tr>
        <th>休日出勤手当​</th>
        <td>{{toFormattedMoney(moneyCounts.holiday)}}</td>
      </tr>
      <tr>
        <th>深夜勤務手当</th>
        <td>{{toFormattedMoney(moneyCounts.late_night)}}</td>
      </tr>
      <tr>
        <th>不足時間控除</th>
        <td>{{toFormattedMoney(moneyCounts.deficit)}}</td>
      </tr>
      <tr class="subtotal">
        <th>小計​</th>
        <td>{{toFormattedMoney(moneyCounts.subtotalSalary)}}</td>
      </tr>

      <tr>
        <th>通勤交通費</th>
        <td>{{toFormattedMoney(moneyCounts.commuting_allowance)}}</td>
      </tr>
      <tr>
        <th>その他交通費​​</th>
        <td>{{toFormattedMoney(moneyCounts.sumTravelExpenses)}}</td>
      </tr>
      <tr>
        <th>立替経費</th>
        <td>{{toFormattedMoney(moneyCounts.sumOtherExpenses)}}</td>
      </tr>
      <tr class="subtotal">
        <th>小計​​</th>
        <td>{{toFormattedMoney(moneyCounts.totalExpences)}}</td>
      </tr>
      <tr class="subtotal">
        <th>総計</th>
        <td>{{toFormattedMoney(moneyCounts.totalSalary)}}</td>
      </tr>
    </table>
    <div class="tableSubTitle">法定福利</div>
    <table>
      <tr>
        <th>健康保険料​</th>
        <td>{{toFormattedMoney(Number(this.owner.kenko_insurance))}}</td>
      </tr>
      <tr>
        <th>厚生年金保険料</th>
        <td>{{toFormattedMoney(Number(this.owner.kouseinenkin_insurance))}}</td>
      </tr>
      <tr>
        <th>労働保険料</th>
        <td>{{toFormattedMoney(moneyCounts.roudou)}}</td>
      </tr>
      <tr class="subtotal">
        <th>計​</th>
        <td>{{toFormattedMoney(moneyCounts.subtotalInsurance)}}</td>
      </tr>
    </table>
  </v-container>
</template>
<script>
import { unixtimeToFormattedLargeTime } from "@/utils/datetime.js";
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  data: () => ({}),
  props: {
  },
  computed: {
    ...mapGetters("timesheet", [ "owner", "moneyCounts"]),
  },
  created() {},
  mounted() {

  },
  methods: {
    toFormattedMoney(m) {
      const money = Number(m);
      return Number.isInteger(money)
        ? "¥ " + money.toLocaleString("ja")
        : "Invalid Money :" + money;
    }
  }
};
</script>
<style lang="scss" scoped>
.tableTitle {
  font-size: 16px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.tableTitle:before {
  content: "";
  background-color: #ff5722;
  display: inline-block;
  height: 15px;
  margin-right: 10px;
  position: relative;
  top: 2px;
  width: 15px;
}
table {
  margin: 10px;
  border: solid 1px;
  border-collapse: collapse;
}
th {
  text-align: left;
}
th,
td {
  border: solid 1px;
  padding: 5px 10px;
}
td {
  text-align: right;
}
.tableSubTitle {
  font-size: 14px;
  color: #616161;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
tr.subtotal{
  font-weight: bold;
  background-color: #FFCCBC;
}
</style>

